var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from 'react';
import moduleStyles from './dance-ai.module.scss';
import AccessibleDialog from '@cdo/apps/templates/AccessibleDialog';
import Button from '@cdo/apps/templates/Button';
import HttpClient from '@cdo/apps/util/HttpClient';
import { CHAT_COMPLETION_URL } from '@cdo/apps/aichat/constants';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '@cdo/apps/util/reduxHooks';
import { setCurrentAiModalField } from './danceRedux';
import { StrongText, Heading5 } from '@cdo/apps/componentLibrary/typography';
import classNames from 'classnames';
import FontAwesome from '@cdo/apps/templates/FontAwesome';
var Typist = require('react-typist').default;
var aiBotBorder = require('@cdo/static/dance/ai-bot-border.png');
var promptString = 'Generate a scene using this mood:';
var doAi = function (input) { return __awaiter(void 0, void 0, void 0, function () {
    var systemPrompt, messages, response, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                systemPrompt = 'You are a helper which can accept a request for a mood or atmosphere, and you then generate JSON like the following format: {backgroundColor: "black", backgroundEffect: "splatter", foregroundEffect: "rain"}.  The only valid values for backgroundEffect are circles, color_cycle, diamonds, disco_ball, fireworks, swirl, kaleidoscope, lasers, splatter, rainbow, snowflakes, galaxy, sparkles, spiral, disco, stars.  The only valid values for backgroundColor are rave, cool, electronic, iceCream, neon, tropical, vintage, warm.  The only valid values for foregroundEffect are bubbles, confetti, hearts_red, music_notes, pineapples, pizzas, smiling_poop, rain, floating_rainbows, smile_face, spotlight, color_lights, raining_tacos.  Make sure you always generate all three of those values.  Also, add a field called "explanation" to the result JSON, which contains a simple explanation of why you chose the values that you did, at the reading level of a 5th-grade school student, in one sentence of less than forty words.';
                messages = [
                    {
                        role: 'system',
                        content: systemPrompt,
                    },
                    {
                        role: 'user',
                        content: input,
                    },
                ];
                console.log('do AI:', input);
                return [4 /*yield*/, HttpClient.post(CHAT_COMPLETION_URL, JSON.stringify({ messages: messages }), true, {
                        'Content-Type': 'application/json; charset=UTF-8',
                    })];
            case 1:
                response = _a.sent();
                if (!(response.status === 200)) return [3 /*break*/, 3];
                return [4 /*yield*/, response.json()];
            case 2:
                res = _a.sent();
                return [2 /*return*/, res.content];
            case 3: return [2 /*return*/, null];
        }
    });
}); };
export var Mode;
(function (Mode) {
    Mode["SELECT_INPUTS"] = "selectInputs";
    Mode["GENERATING"] = "generating";
    Mode["RESULTS"] = "results";
})(Mode || (Mode = {}));
var DanceAiModal = function (_a) {
    var onClose = _a.onClose;
    var dispatch = useAppDispatch();
    var SLOT_COUNT = 3;
    var inputLibraryFilename = 'ai-inputs';
    var inputLibrary = require("@cdo/static/dance/".concat(inputLibraryFilename, ".json"));
    var _b = useState(Mode.SELECT_INPUTS), mode = _b[0], setMode = _b[1];
    var _c = useState(0), currentInputSlot = _c[0], setCurrentInputSlot = _c[1];
    var _d = useState([]), inputs = _d[0], setInputs = _d[1];
    var _e = useState(''), responseParams = _e[0], setResponseParams = _e[1];
    var _f = useState(''), responseExplanation = _f[0], setResponseExplanation = _f[1];
    var _g = useState(false), typingDone = _g[0], setTypingDone = _g[1];
    var currentAiModalField = useSelector(function (state) { return state.dance.currentAiModalField; });
    var getImageUrl = function (id) {
        return "/blockly/media/dance/ai/".concat(id, ".png");
    };
    var getAllItems = function (slotIndex) {
        if (slotIndex >= SLOT_COUNT) {
            return [];
        }
        return inputLibrary.options[slotIndex].map(function (option) {
            var item = inputLibrary.items.find(function (item) { return item.id === option; });
            return {
                id: item.id,
                name: item.name,
                url: getImageUrl(item.id),
            };
        });
    };
    var getItemName = function (id) {
        var _a;
        return (_a = inputLibrary.items.find(function (item) { return item.id === id; })) === null || _a === void 0 ? void 0 : _a.name;
    };
    var handleItemClick = function (id) {
        if (currentInputSlot < SLOT_COUNT) {
            setInputs(__spreadArray(__spreadArray([], inputs, true), [id], false));
            setCurrentInputSlot(currentInputSlot + 1);
        }
    };
    var handleGeneratingClick = function () {
        setMode(Mode.RESULTS);
    };
    var handleGenerateClick = function () {
        var inputNames = inputs.map(function (input) {
            return inputLibrary.items.find(function (item) { return item.id === input; }).name;
        });
        var request = "".concat(promptString, " ").concat(inputNames.join(', '), ".");
        startAi(request);
        setMode(Mode.GENERATING);
    };
    var startAi = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var response, params, picked, pickedString;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, doAi(value)];
                case 1:
                    response = _a.sent();
                    params = JSON.parse(response);
                    currentAiModalField === null || currentAiModalField === void 0 ? void 0 : currentAiModalField.setValue(response);
                    picked = (function (_a) {
                        var backgroundEffect = _a.backgroundEffect, backgroundColor = _a.backgroundColor, foregroundEffect = _a.foregroundEffect;
                        return ({ backgroundEffect: backgroundEffect, backgroundColor: backgroundColor, foregroundEffect: foregroundEffect });
                    })(params);
                    pickedString = JSON.stringify(picked)
                        .replace(/":"/g, '": "')
                        .replace(/","/g, '", "');
                    setResponseParams("ai(".concat(pickedString, ")"));
                    setResponseExplanation(params.explanation);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDoneClick = function () {
        dispatch(setCurrentAiModalField(undefined));
    };
    return (React.createElement(AccessibleDialog, { className: moduleStyles.dialog, onClose: onClose, initialFocus: false },
        React.createElement("div", { id: "inner-area", className: moduleStyles.innerArea },
            React.createElement("div", { id: "text-area", className: moduleStyles.textArea },
                React.createElement(StrongText, null,
                    ' ',
                    mode === Mode.SELECT_INPUTS
                        ? 'Make a sentence by selecting some emoji.'
                        : mode === Mode.GENERATING && responseParams === ''
                            ? 'The AI is processing your sentence.'
                            : mode === Mode.GENERATING && responseParams !== ''
                                ? 'The AI is ready to generate results!'
                                : mode === Mode.RESULTS && !typingDone
                                    ? 'The AI is generating results.'
                                    : mode === Mode.RESULTS && typingDone
                                        ? 'This is the result generated by the AI.'
                                        : undefined)),
            React.createElement("div", { id: "inputs-area", className: moduleStyles.inputsArea, style: { zIndex: mode === Mode.SELECT_INPUTS ? 1 : 0 } }, mode === Mode.SELECT_INPUTS && currentInputSlot < SLOT_COUNT && (React.createElement("div", { className: moduleStyles.itemContainer }, getAllItems(currentInputSlot).map(function (item, index) {
                return (React.createElement("div", { tabIndex: index === 0 && currentInputSlot === 0 ? 0 : undefined, key: item.id, onClick: function () { return handleItemClick(item.id); }, style: { backgroundImage: "url(".concat(item.url, ")") }, className: moduleStyles.item, title: item.name }));
            })))),
            React.createElement("div", { id: "prompt-area", className: moduleStyles.promptArea, style: {
                    zIndex: mode === Mode.SELECT_INPUTS || mode === Mode.GENERATING ? 1 : 0,
                } }, (mode === Mode.SELECT_INPUTS ||
                (mode === Mode.GENERATING && responseParams === '')) && (React.createElement("div", { className: moduleStyles.prompt },
                promptString,
                Array.from(Array(SLOT_COUNT).keys()).map(function (index) {
                    return (React.createElement("div", { key: index, className: moduleStyles.inputContainer },
                        index === currentInputSlot && (React.createElement("div", { className: classNames(moduleStyles.arrowDown, currentInputSlot === 0 &&
                                moduleStyles.arrowDownFirstAppear) }, "\u00A0")),
                        React.createElement("div", { className: moduleStyles.inputBackground }, "\u00A0"),
                        inputs[index] && (React.createElement("div", { style: {
                                backgroundImage: "url(".concat(getImageUrl(inputs[index])),
                            }, className: moduleStyles.inputItem, title: getItemName(inputs[index]) }))));
                })))),
            React.createElement("div", { id: "bot-area", className: moduleStyles.botArea },
                ((mode === Mode.SELECT_INPUTS && currentInputSlot >= SLOT_COUNT) ||
                    mode === Mode.GENERATING ||
                    mode === Mode.RESULTS) && (React.createElement("div", { className: moduleStyles.botContainer },
                    React.createElement("img", { src: aiBotBorder, className: classNames(moduleStyles.bot, mode === Mode.SELECT_INPUTS
                            ? moduleStyles.botAppearCentered
                            : mode === Mode.GENERATING
                                ? moduleStyles.botAppearCentered
                                : mode === Mode.RESULTS
                                    ? moduleStyles.botCenterToLeft
                                    : undefined) }))),
                mode === Mode.GENERATING && responseParams === '' && (React.createElement("div", { className: moduleStyles.spinner },
                    React.createElement(FontAwesome, { title: undefined, icon: "spinner", className: classNames('fa-pulse', 'fa-3x') })))),
            React.createElement("div", { id: "outputs-area", className: moduleStyles.outputsArea, style: { zIndex: mode === Mode.RESULTS ? 1 : 0 } }, mode === Mode.RESULTS && (React.createElement(Typist, { startDelay: 1500, avgTypingDelay: 30, cursor: { show: false }, onTypingDone: function () {
                    setTypingDone(true);
                } },
                React.createElement(Heading5, null, "Code"),
                React.createElement("pre", { className: moduleStyles.pre }, responseParams),
                React.createElement(Heading5, null, "Explanation"),
                React.createElement("pre", { className: moduleStyles.pre }, responseExplanation)))),
            React.createElement("div", { className: moduleStyles.buttonsArea },
                mode === Mode.SELECT_INPUTS && currentInputSlot >= SLOT_COUNT && (React.createElement(Button, { id: "select-all-sections", text: 'Process', onClick: handleGenerateClick, color: Button.ButtonColor.brandSecondaryDefault, className: moduleStyles.button })),
                mode === Mode.GENERATING && responseParams !== '' && (React.createElement(Button, { id: "done", text: 'Generate results', onClick: handleGeneratingClick, color: Button.ButtonColor.brandSecondaryDefault, className: moduleStyles.button })),
                mode === Mode.RESULTS && typingDone && (React.createElement(Button, { id: "done", text: 'Done', onClick: handleDoneClick, color: Button.ButtonColor.brandSecondaryDefault, className: moduleStyles.button }))))));
};
export default DanceAiModal;
